export default __webpack_public_path__ + "static/favicon-fadde64fc7596618dbd13db637bc7556.png";